import { ImageIcon } from 'lucide-react'
import type { SlotKey } from '../slotRegistry'
import type { ImageSlotDocument } from '@/types'

interface DesignerOverlayProps {
  slotKey: SlotKey
  assignment: ImageSlotDocument | null
  onEdit: () => void
}

export function DesignerOverlay({ assignment, onEdit }: DesignerOverlayProps) {
  return (
    <button
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onEdit()
      }}
      title={assignment ? 'Change image' : 'Assign image'}
      className="absolute bottom-2 right-2 z-50 flex items-center gap-1.5 rounded-md bg-black/60 px-2.5 py-1.5 text-xs font-medium text-white backdrop-blur-sm transition-opacity opacity-0 group-hover/slot:opacity-100 hover:bg-black/80"
    >
      <ImageIcon className="h-3 w-3" />
      {assignment ? 'Change image' : 'Assign image'}
    </button>
  )
}
